export default __webpack_public_path__ + "static/media/AS.ccef495b.svg";